import {BaseMuWidget} from "../../BaseMuWidget";
import {MuEvent, MuNamedWidgets} from "mu-widget/lib/MuWidget";
import {TreeItemSrcData, TreeSelector, TreeSelectorItem} from "../../TreeSelector";
import {SlashTree} from "../../SlashTree";
import {createHtmlElement} from "../../Utils";

export class UiPqmFilter extends BaseMuWidget {
    beforeIndex() {
        this.muRegisterEvent('change');
        this.muAppendContent(`<div mu="tree:TreeSelector"></div>`)
    }

    // @ts-ignore
    muNamedWidget: MuNamedWidgets<{
        tree:TreeSelector
    }>

    public bindData(data: any[]) {
        data = [
            { name: 'vše', pqmItemId: "none" },
            ...data,
        ]
        const tree = this.muNamedWidget.tree;
        tree.afterItemRender = (item) => {
            if (!item.data.pqmItemId) {
                item.ui.title.classList.add('strong');
            } else {
                item.ui.title.classList.add('icon-before-document-dir');
                item.muVisible(false, 'bCollapse');
            }
            if (item.data.count) item.ui.title.append(createHtmlElement(
                'span',
                {
                    'class': 'badge bg-secondary float-right',
                },
                item.data.count.toString()
            ))
        }
        const st = new SlashTree(data, 'name');
        const treeData = st.exportAs(
            node => {
                return {
                    data: node.data,
                    id: node.key,
                    children: node.items,
                    title: node.name,
                } as unknown as TreeItemSrcData;
            },
            "children"
        ).children as TreeItemSrcData[];
        tree.bindTree(treeData);
    }

    tree_change(ev: MuEvent, a: string, ti: TreeSelectorItem) {
        if (ti.data.pqmItemId) {
            this.muDispatchEvent('change', ti.data.pqmItemId === "none" ? null : ti.data.pqmItemId, ti.data.pqmItems);
        } else {
            ti.bCollapse_click();
            this.muNamedWidget.tree.setSelected(
                this.callMethodInFirstAncestors('getLastPqmItemId'),
                false
            );
        }
    }
}